export const STATE_KEY_PREFIX = '@@bgpm_appstate';
export const BGPM_APP_STATE = '___BGPM_APP_STATE';
export const DELIM = '||';
